import {type FormEventHandler, useState} from 'react';
import {useIntl} from 'react-intl';
import {Input} from '@time-webkit/all/atoms';
import {CheckNewIcon} from '@time-webkit/all/icons';
import {type Editor} from '@tiptap/react';
import {sendToStatist} from 'packages/statist';

import {ActionButton} from '../../action-button';
import {hasProtocol, prepareForm} from '../utils';

import styles from './floating-link-popover-form.module.css';

type FloatingLinkPopoverFormProps = {
    editor?: Editor;
    onTogglePopover: () => void;
}

export const FloatingLinkPopoverForm = ({editor, onTogglePopover}: FloatingLinkPopoverFormProps) => {
    const {formatMessage} = useIntl();
    const [linkValue, setLinkValue] = useState('');

    const handleSubmit: FormEventHandler = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (!editor || linkValue.trim().length === 0) {
            onTogglePopover();
            return;
        }

        const {url} = prepareForm(linkValue);

        sendToStatist('editor.link.apply', {
            highlight: true,
            insert: false,
            text: false,
            protocol: hasProtocol(linkValue.trim()),
        });

        editor.commands.addLinkToSelection({href: url});
        onTogglePopover();
    };

    const label = formatMessage({id: 'editor.link-popover.link-field.label', defaultMessage: 'Link'});
    return (
        <form className={styles.floatingLinkPopoverForm} onSubmit={handleSubmit}>
            <Input
                className={styles.linkInput}
                value={linkValue}
                onChange={setLinkValue}
                aria-label={label}
                placeholder={label}
            />

            <div className={styles.buttonsWrapper}>
                <ActionButton
                    icon={<CheckNewIcon className={styles.checkIcon}/>}
                    type='submit'
                />
            </div>
        </form>
    );
};
